// frontend/src/components/onboarding/OnboardingWizard.js
import React, { useState , useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, ProgressBar } from 'react-bootstrap';
import toast from 'react-hot-toast';
import Step1Username from './Step1Username';
import Step2Splash from './Step2Splash';
import { api , onboardingService} from '../../utils/Api';
import { useAuth } from '../../context/AuthContext';


const OnboardingWizard = ({ user }) => {
  const { updateUser } = useAuth();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: user?.email?.split('@')[0] || '',
    displayName: user?.name || ''
  });
  
  const navigate = useNavigate();

  // LOG 3: Al montar el wizard
  useEffect(() => {
    console.log('🎯 [OnboardingWizard] MONTADO');
    console.log('🎯 [OnboardingWizard] user recibido:', user);
    console.log('🎯 [OnboardingWizard] formData inicial:', formData);
  }, []);

  // LOG 4: Cada vez que cambia formData
  useEffect(() => {
    console.log('📝 [OnboardingWizard] formData actualizado:', formData);
  }, [formData]);

  const handleNext = async () => {
    console.log('➡️ [OnboardingWizard] handleNext - step:', step);
    
    if (step === 1) {
      console.log('🔍 [OnboardingWizard] Validando username:', formData.username);
      setLoading(true);

    if (formData.username === user?.username) {
      console.log('✅ Username no cambió, avanzando directamente');
      setStep(2);
      setLoading(false);
      return;
    }
      
      try {
        const response = await onboardingService.checkUsername(formData.username);
        
        console.log('📥 [OnboardingWizard] Respuesta check-username:', response.data);
        
        if (response.data.available) {
          console.log('✅ [OnboardingWizard] Username disponible, pasando a paso 2');

          try {
            await onboardingService.updateUsername(formData.username);
            console.log('✅ Username actualizado en el backend');
            
            // Actualizar el usuario en localStorage
            const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
            currentUser.username = formData.username;
            localStorage.setItem('user', JSON.stringify(currentUser));
            
            setStep(2);

          } catch (updateError) {
            console.error('Error actualizando username:', updateError);
            toast.error('Error al guardar el nombre de usuario');
          }
          
        } else {
          console.log('❌ [OnboardingWizard] Username no disponible');
          toast.error('Este nombre de usuario no está disponible');
        }
      } catch (error) {
        console.error('❌ [OnboardingWizard] Error verificando username:', error);
        toast.error('Error verificando disponibilidad');
      } finally {
        setLoading(false);
      }
    } else {
      console.log('💾 [OnboardingWizard] Completando onboarding con:', formData);
      
      try {
        const response = await onboardingService.completeOnboarding(formData);
        console.log('📥 [OnboardingWizard] Respuesta complete-onboarding:', response.data);
        
        toast.success('¡Todo listo!');
        console.log('✅ [OnboardingWizard] Onboarding completado, redirigiendo...');
        updateUser({ hasOnboarded: true, username: formData.username, name: formData.displayName });
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('❌ [OnboardingWizard] Error guardando:', error);
        toast.error('Error al guardar');
      }
    }
  };

  const handleBack = () => {
    console.log('⬅️ [OnboardingWizard] Volviendo al paso', step - 1);
    setStep(step - 1);
  };

  const steps = [
    { number: 1, label: 'Elige tu nombre público' },
    { number: 2, label: 'Cómo funcionan las imágenes' }
  ];

  console.log('🎨 [OnboardingWizard] Render - step:', step, 'loading:', loading);

  return (
    <Card className="shadow-sm border-0">
      <Card.Body className="p-4">
        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            {steps.map(s => (
              <small 
                key={s.number}
                className={`fw-bold ${step >= s.number ? 'text-primary' : 'text-muted'}`}
              >
                Paso {s.number}
              </small>
            ))}
          </div>
          <ProgressBar 
            now={(step / steps.length) * 100} 
            variant="primary"
            style={{ height: '6px' }}
          />
        </div>

        {step === 1 && (
          <Step1Username 
            formData={formData}
            setFormData={setFormData}
            loading={loading}
            originalUsername={user?.username} 
          />
        )}

        {step === 2 && (
          <Step2Splash />
        )}

        <div className="d-flex justify-content-between mt-4 pt-3 border-top">
          <div>
            {step > 1 && (
              <button
                className="btn btn-outline-secondary"
                onClick={handleBack}
              >
                ← Volver
              </button>
            )}
          </div>
          <button
            className={`btn ${step === steps.length ? 'btn-success' : 'btn-primary'} px-4`}
            onClick={handleNext}
            disabled={loading}
          >
            {step === steps.length ? 'Ir al Dashboard' : 'Continuar'}
            {step < steps.length && ' →'}
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OnboardingWizard;